import { CoDocumentDetailFragment, DocumentType, FiscalType } from 'src/api/api.generated'

export const calculateVatAmount = (total: number, vat: number) => {
  return total - total / (1 + vat)
}

export default function calculateCoTaxes(documentInfo: CoDocumentDetailFragment[], fiscalDepositsAmount: Map<number, number>, nonFiscalDepositsAmount: number) {
  let tmpNonFiscalDepositsAmount = nonFiscalDepositsAmount
  const taxes = documentInfo //
    .filter((dd) => !dd.referenceDocument || dd.referenceDocument.documentType !== DocumentType.ADVANCE) // Se non è già stato emesso come documento o se è stato emesso ma non è un doc di anticipo
    .map((dd) => {
      let documentAmountWithTaxes = dd.totalAmount
      const tmpDocVatValue = dd.vat?.value ?? -1

      const tmpFiscalDepositsAmount = fiscalDepositsAmount.get(tmpDocVatValue)

      if (tmpFiscalDepositsAmount) {
        if (documentAmountWithTaxes > tmpFiscalDepositsAmount) {
          documentAmountWithTaxes = documentAmountWithTaxes - tmpFiscalDepositsAmount
          fiscalDepositsAmount.set(tmpDocVatValue, 0)
        } else {
          fiscalDepositsAmount.set(tmpDocVatValue, tmpFiscalDepositsAmount - documentAmountWithTaxes)
          documentAmountWithTaxes = 0
        }
      }

      if (tmpNonFiscalDepositsAmount > 0 && documentAmountWithTaxes > 0) {
        if (documentAmountWithTaxes > tmpNonFiscalDepositsAmount) {
          tmpNonFiscalDepositsAmount = 0
        } else {
          tmpNonFiscalDepositsAmount = tmpNonFiscalDepositsAmount - documentAmountWithTaxes
        }
      }

      return { amount: documentAmountWithTaxes, vat: dd?.vat?.value ?? 0 }
    })

  const taxesMap: Map<number, number> = new Map()
  taxes.forEach((tax) => {
    taxesMap.set(tax.vat, (taxesMap.get(tax.vat) ?? 0) + tax.amount)
  })

  return Array.from(taxesMap.keys()).reduce((prev, curr) => prev + calculateVatAmount(taxesMap.get(curr) ?? 0, curr), 0)
}

export function calculateFiscalAdvanceAmount(deposits: { fiscalType: FiscalType; vatPercentage: number; usedAmount: number | null }[]) {
  const fiscalDepositsAmount = new Map<number, number>([]) // key is vatPercentage, value is the amount with the vatPercentage

  deposits?.forEach((deposit) => {
    if (deposit.fiscalType !== 'NON_FISCAL') {
      const key = deposit.vatPercentage
      fiscalDepositsAmount.set(key, (fiscalDepositsAmount.get(key) ?? 0) + (deposit.usedAmount ?? 0))
    }
  })

  return fiscalDepositsAmount
}
